<template>
    <ListEditForm
        class="EducationEdit"
        :form-component="formComponent"
        :max-items="secondary ? 1 : undefined"
        :new-item-generator="newSchool"
        :new-item-label="addItemLabel"
        :value="modelValue"
        v-bind="$attrs"
        @input="$emit('update:modelValue', $event)"
    />
</template>

<script setup lang="ts">
import { computed } from 'vue'
import type { PropType, Component } from 'vue'

import { defaultSchool, type School } from '#shared/types/User'
import HighSchoolForm from '@/components/profile/HighSchoolForm.vue'
import ListEditForm from '@/components/profile/ListEditForm.vue'
import UniversityForm from '@/components/profile/UniversityForm.vue'

const props = defineProps({
    secondary: {
        type: Boolean,
        default: false
    },
    modelValue: {
        type: Array as PropType<School[]>,
        default: () => []
    }
})

const emit = defineEmits(['update:modelValue'])

const newSchool = () => ({ ...defaultSchool })

const addItemLabel = computed(() => {
    return props.secondary ? 'Pridať strednú školu' : 'Pridať vysokú školu'
})

const formComponent = computed((): Component => {
    return props.secondary ? HighSchoolForm : UniversityForm
})
</script>